<mat-card>
    <div class="card-header-container">
        <img class="accessory-box-img"
            [src]="'/files/profile/' + profile?.img"
            [alt]="profile?.name"
            defaultImg>
        <mat-card-header>
            <mat-card-title class="accessory-box-title">{{profile?.name}}</mat-card-title>
            <mat-card-subtitle class="accessory-box-description"></mat-card-subtitle>
        </mat-card-header>
    </div>
  <mat-card-content>
      <form [formGroup]="form">
          <div *ngIf="profile?.type === 'extension' || profile?.type === 'sandwich' || profile?.type === 'coupling' && showColorsWhenCoupling || showColorsInComplementary">
              <button mat-raised-button
                      (click)="openModalColors()">{{ 'INTERFACE|Kolory' | translate }}</button>
              <button mat-raised-button
                      *ngIf="config().IccConfig.Configurators.extensionsReinforcements && profile?.type === 'extension'"
                      (click)="openModalReinforcements(profile)">{{ 'WINDOW|Wzmocnienie' | translate }}</button>
                <span
                      *ngIf="config().IccConfig.Configurators.extensionsReinforcements && profile?.type === 'extension'">{{ 'WINDOW|Wzmocnienie' | translate }}:
                    <b *ngIf="profile?.reinforcement?.name">{{ profile?.reinforcement?.name }}</b>
                    <b *ngIf="!profile?.reinforcement?.name">{{ 'INTERFACE|Brak' | translate }}</b>
                    <br />
                </span>
              <span *ngIf="profile?.selectedWood?.name">{{ 'WINDOW|Rodzaj drewna' | translate }}:
                  <b
                     >{{ profile?.selectedWood?.name }}</b>
                  <br />
                  </span>
                  <span
                        *ngIf="profile?.selectedColor?.frame?.outer?.name">{{ 'COLOR|Kolor zewn.' | translate }}:
                      <b
                         >{{ profile?.selectedColor?.frame?.outer?.name }}</b>
                      <br />
                  </span>
                  <span
                        *ngIf="profile?.selectedColor?.frame?.inner?.name">{{ 'COLOR|Kolor wewn.' | translate }}:
                      <b
                         >{{ profile?.selectedColor?.frame?.inner?.name }}</b>
                      <br />
                  </span>
                  <span
                        *ngIf="profile?.selectedColor?.frame?.core?.name && showCoreColorInAdditionalProfilesAndAccessories">{{ 'WINDOW|Rdzeń' | translate }}:
                      <b
                         >{{ profile?.selectedColor?.frame?.core?.name }}</b>
                      <br />
                  </span>
          </div>

          <mat-form-field *ngIf="optionsInComplementary">
              <input matInput type="number" min="1"
                     [placeholder]="'INTERFACE|Ilość' | translate"
                     formControlName="count">
          </mat-form-field>
          <mat-form-field *ngIf="optionsInComplementary">
              <input matInput iccDimensionInput type="number" min="0.01" step="0.01"
                     formControlName="currentLength"
                     [placeholder]="'DIMENSION|Długość' | translate">
              <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
          </mat-form-field>
          <mat-form-field *ngIf="profile?.type === 'sandwich'">
                <input matInput iccDimensionInput type="number" [placeholder]="'DIMENSION|Wysokość' | translate" [min]="profile?.minHeight" [max]="profile?.maxHeight" formControlName="width">
                <span matSuffix>{{dimensionUnit.unitSymbol}}</span>
          </mat-form-field>
          <mat-form-field *ngIf="optionsInComplementary">
            <input matInput type="text" formControlName="comment"
                   [placeholder]="'INTERFACE|Komentarz' | translate">
          </mat-form-field>
          <h4>{{ 'OFFER|Cena' | translate }}:
            <b>
                <span
                        *ngIf="hasZeroPrice(profile?.price, profile?.type)">{{ 'CONFIGURATOR|W cenie' | translate }}<br></span>
                <span
                        *ngIf="hasNoPrice(profile?.price, profile?.type)">{{ 'CONFIGURATOR|Do wyceny' | translate }}<br></span>
                <span
                        *ngIf="!hasZeroPrice(profile?.price, profile?.type) && ! hasNoPrice(profile?.price, profile?.type)">
                    <span
                            *ngIf="profile?.price.price_field && (!config().IccConfig.Configurators.price.frameProfilesAlt || profile?.type != 'frame')">{{priceMarket(profile?.price.price_field) | currency: currency}}/{{ 'WINDOW|pole' | translate }}<br></span>
                    <span
                            *ngIf="profile?.price.price_length && (!config().IccConfig.Configurators.price.frameProfilesAlt || profile?.type != 'frame')">{{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}{{priceMarket(profile?.price.price_length) | unitm:0:0:3 | currency: currency}}/<span
                                [innerHTML]="2|formatUnit"></span><br></span>
                    <span
                            *ngIf="profile?.price.price_area">{{profile?.price.price_area | currency: currency}}/<span
                                [innerHTML]="1|formatUnit"></span><br></span>
                    <span
                            *ngIf="profile?.price.price_field != profile?.price.price_length &&  config().IccConfig.Configurators.price.frameProfilesAlt && profile?.type == 'frame'">{{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}{{priceMarket(profile?.price.price_length) | unitm:0:0:3 | currency: currency}}/<span
                                [innerHTML]="2|formatUnit"></span> <span
                                *ngIf="profile?.price.price_field">{{ 'INTERFACE|lub' | translate }}&nbsp;{{priceMarket(profile?.price.price_field) | unitm:0:0:3 | currency: currency}}/<span
                                    [innerHTML]="2|formatUnit"></span></span><br></span>
                    <span
                            *ngIf="profile?.price.price_length && profile?.price.price_field == profile?.price.price_length &&  config().IccConfig.Configurators.price.frameProfilesAlt && profile?.type == 'frame'">{{dimensionUnit.unitSymbol != 'mm' ? '~' : ''}}{{priceMarket(profile?.price.price_length) | unitm:0:0:3 | currency: currency}}/<span
                                [innerHTML]="2|formatUnit"></span><br></span>
                    <span
                            *ngIf="profile?.price.price_piece">{{profile?.price.price_piece | currency: currency}}/{{ 'DIMENSION|szt.' | translate }}<br></span>
                    <span
                            *ngIf="profile?.price.price_construction">{{profile?.price.price_construction | currency: currency}}/{{ 'DIMENSION|konstrukcja' | translate }}<br></span>
                    <span
                            *ngIf="profile?.price.price_percent">{{profile?.price.price_percent}}%</span>
                </span>
            </b>
        </h4>
      </form>

      <section class="casing" *ngIf="profile?.type === 'frame'">
        <mat-checkbox [hidden]="profile?.onlyWithCasingCover" (change)="toggleCasing($event)" value="isCasingAvailableForFrame"  [checked]="isCasingOptionsSelected" >{{ 'WINDOW|Dodaj obejmę' | translate  }}</mat-checkbox>
          <form [formGroup]="casingForm" *ngIf="profile?.onlyWithCasingCover|| isCasingOptionsSelected && casingForm">
            <mat-form-field>
                <mat-label>{{ 'WINDOW|Szerokość muru' | translate }} </mat-label>
                <input matInput formControlName="casingWallWidth" [value]="casingForm?.casingWallWidth" required>
                    <mat-hint>{{ 'WINDOW|Wartość powinna mieścić się w zakresie od' | translate }} 
                        {{lowestInnerCasingWidth}} {{dimensionUnit.unitSymbol}} {{ 'WINDOW|do' | translate }}
                        {{highestInnerCasingWidth}} {{dimensionUnit.unitSymbol}} {{ 'WINDOW|ze skokiem co' | translate }}
                        {{CASING_GAP}} {{dimensionUnit.unitSymbol}}.
                    </mat-hint>
                    <mat-error *ngIf="casingForm?.get('casingWallWidth').hasError('casingGapError')">
                        {{ 'WINDOW|Wartość powinna mieścić się w zakresie od' | translate }}
                        {{lowestInnerCasingWidth}} {{dimensionUnit.unitSymbol}} {{ 'WINDOW|do' | translate }}
                        {{highestInnerCasingWidth}} {{dimensionUnit.unitSymbol}} {{ 'WINDOW|ze skokiem co' | translate }}
                        {{CASING_GAP}} {{dimensionUnit.unitSymbol}}.
                    </mat-error>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>{{ 'WINDOW|Wyłożenie na mur' | translate }} [{{dimensionUnit.unitSymbol}}]</mat-label>
                <mat-select [disabled]="casingWallOverlap.length === 1" formControlName="casingWallOverlap"  (selectionChange)="changeCasingBasedOnInnerWidthAndWallOverlap()" >
                    <mat-option  *ngFor="let overlap of casingWallOverlap" [value]="overlap" >
                    {{overlap}}
                </mat-option>
            </mat-select> 

            </mat-form-field>
          </form>
      </section>
  </mat-card-content>
  <mat-card-actions>
    <button [disabled]="(!casingForm?.valid && isCasingOptionsSelected) || (profile?.onlyWithCasingCover && !casingForm?.valid)" mat-raised-button color="primary" (click)="add()">{{ 'INTERFACE|Dodaj' | translate }}</button>
  </mat-card-actions>
</mat-card>
